import React, { Component } from "react";
import QRCode from 'react-qr-code';
import {isMobile} from 'react-device-detect';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import SmallCard from './small';
import './media.css';
import M from 'materialize-css/dist/js/materialize.min.js'
import Modal from '../helper/modal';
import Start from "../Passport/Upload/start";

// import {addMedia} from '../../../actions/ui/marketplace';

let kg = {
  viewCard:true,
  name: 'KG Coin',
  ticker: 'KG',
  description: 'This is a short description of the asset. It allows the user to understand the use of the asset.',
  total: 10000000,
  circulating: 5000000,
  balance: 0
};

class Media extends Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(){
    super()
    this.state = {
      view:'people'
    }
  }
  componentDidMount(){
    let location = this.props.location.search;
    if (location.length > 0){
      let [name,time] = location.substring(1).split(',');
      this.getData(name,time);
    }
    let _this = this;
    setTimeout(()=>{
      if(_this.props.loggedIn) window.localStorage.removeItem(`location`)
      else window.localStorage.setItem(`location`,window.location.href)
    },1000);
  }
  getData(name,time){
    if(name === 'kg'){
      let balance = window.localStorage.getItem(`KG.${this.props.address}`);
      this.setState({
        viewCard:true,
        name: 'KG Coin',
        ticker: 'KG',
        description: 'This is a short description of the asset. It allows the user to understand the use of the asset.',
        total: 10000000,
        circulating: 5000000,
        balance: balance ? balance : 0
      })
    }
  }
  renderCard(){
    let balance = window.localStorage.getItem(`${this.state.ticker}.${this.props.address}`);
    return (
      <>
      <div className="card center" style={{border:'1px solid grey',width:'350px',borderRadius:'5%'}}>
        <div className="card-image" style={{height:'250px'}}>
          <div className='center' style={{position:'absolute',top:'15px',marginLeft:'65px',height:'220px',width:'220px',border:'5px solid black',background:'white',borderRadius:'50%',padding:'10px'}}>
             <img className='circle' style={{borderRadius:'50%',border:'2px solid black'}} src="./kg.jpg"/>
          </div>
        </div>
        <div className="card-content mediaSupply" style={{paddingTop:'10px'}}>
          <span className="card-title" style={{color:'black'}}>{this.state.name}</span>
          <p style={{marginBottom:'10px'}}>{this.state.description}</p>
          <div className='row'>
             <p style={{float:'left',margin:'10px 0px',color:'grey'}}> Total Supply</p>
             <p style={{float:'right',margin:'10px 0px'}}>{this.state.total} {this.state.ticker}</p>
          </div>
          <div className='row'>
             <p style={{float:'left',margin:'10px 0px',color:'grey'}}> Circulating Supply</p>
             <p style={{float:'right',margin:'10px 0px'}}>{this.state.circulating} {this.state.ticker}</p>
          </div>
          <div className='row'>
             <p style={{float:'left',margin:'10px 0px',color:'grey'}}> Balance</p>
             <p style={{float:'right',margin:'10px 0px'}}>{this.state.balance} {this.state.ticker}</p>
          </div>
        </div>
      </div>
      <div className='col s12' style={{marginTop:'5px'}}>
        {!this.props.loggedIn ?
         <Start/>
         :
         <>
         <div className='col s6'>
           <button onClick={this.addMedia.bind(this)} style={{padding:0,width:'120px',marginBottom:'5px',height:'28px',lineHeight:'28px',fontSize:'15px'}} action="submit" className={"btn clickables"} > {balance ? '+0' : '+100'} {this.state.ticker}</button>
         </div>
         <div className='col s6'>
           <button onClick={this.noMedia.bind(this)}  style={{padding:0,width:'120px',marginBottom:'5px',height:'28px',lineHeight:'28px',fontSize:'15px'}} action="submit" className={"btn clickablesRed"} >+0 {this.state.ticker}</button>
         </div>
         </>
         }
      </div>
      </>
    )
  }
  noMedia(){
    this.setState({viewCard:false})
    // window.location.href = `http://borderless-internal.blockcollider.org.s3-website.us-east-2.amazonaws.com/#/media`;
  }
  addMedia(){
    let balance = window.localStorage.getItem(`${this.state.ticker}.${this.props.address}`);
    let _this = this;
    if(!balance) {
      this.setState({balance:1000})
      M.toast({html: `1000 ${this.state.ticker} added to your wallet.`,classes: "green",displayLength:3000});
      kg.balance = 1000;
      setInterval(()=>{
        _this.setState({viewCard:false})
        window.localStorage.setItem(`${_this.state.ticker}.${_this.props.address}`,1000);
        // window.location.href = `http://borderless-internal.blockcollider.org.s3-website.us-east-2.amazonaws.com/#/media`;
      },1000)
    }
    else {
      _this.setState({viewCard:false})
      window.localStorage.setItem(`${_this.state.ticker}.${_this.props.address}`,1000);
      // window.location.href = `http://borderless-internal.blockcollider.org.s3-website.us-east-2.amazonaws.com/#/media`;
    }
  }
  setView(view) {
    this.setState({ view });
  }
  renderMobile(){
    let mnemStyle = this.state.view === "people" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px'};
    let jsonStyle = this.state.view === "companies" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px' };
    let privStyle = this.state.view === "events" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px'};

    return (
      <div clasName='col s12' style={{height:'50px',marginTop:'10px'}}>
        <div className="col s4">
          <div onClick={this.setView.bind(this, "people")} className='B' style={{cursor:'pointer',border:this.state.view === "people" ? '1px solid white':'1px solid grey'}}>
            <h5 className='mediaHeading' style={mnemStyle}> people </h5>
          </div>
        </div>
        <div className="col s4">
          <div onClick={this.setView.bind(this, "companies")} className='C' style={{cursor:'pointer',border:this.state.view === "companies" ? '1px solid white':'1px solid grey'}}>
            <h5 className='mediaHeading' style={jsonStyle}> companies </h5>
          </div>
        </div>
        <div className="col s4">
          <div onClick={this.setView.bind(this, "events")} className='D' style={{cursor:'pointer',border:this.state.view === "events" ? '1px solid white':'1px solid grey'}}>
            <h5 className='mediaHeading' style={privStyle}> events </h5>
          </div>
        </div>
      </div>
    )
  }
  render() {
    return (
      <div className='container center'>
        <div className="row" style={{maxWidth:'350px',marginTop:'5px'}}>
         <div className="col s12">
          {this.state.viewCard && this.renderCard()}
          {!this.state.viewCard && this.renderMobile()}
          {!this.state.viewCard &&
            <>
            {this.state.view === 'people' ?
            <div className='col s6'>
              <SmallCard address={this.props.address} name={kg.name} ticker={kg.ticker} total={kg.total} circulating={kg.circulating} description={kg.description} balance={kg.balance}/>
            </div>
            :
            <div className='col s6'>
              <SmallCard name={'***'} ticker={''} total={''} circulating={''} description={''} balance={''}/>
            </div>
            }
            <div className='col s6'>
              <SmallCard name={'***'} ticker={''} total={''} circulating={''} description={''} balance={''}/>
            </div>
            <div className='col s6'>
              <SmallCard name={'***'} ticker={''} total={''} circulating={''} description={''} balance={''}/>
            </div>
            <div className='col s6'>
              <SmallCard name={'*** '} ticker={''} total={''} circulating={''} description={''} balance={''}/>
            </div>
            </>
          }
         </div>
       </div>
      </div>
    );
  }
}

function mapStateToProps(state,props) {
  return {
    address: state.passport.tradeAddresses.nrg,
    loggedIn:
      state.passport.wallet.emb &&
      state.passport.wallet.nrg &&
      state.passport.wallet["l-emb"] &&
      Object.keys(state.passport.wallet.emb).length > 0,
  };
}

export default connect(mapStateToProps, {
  // addMedia
})(withRouter(props => <Media {...props}/>));
